"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedString = void 0;
const accounting_1 = require("accounting");
function getFormattedString(value, { emptyValue, precision, separators }, formatNumber = accounting_1.formatNumber) {
    return typeof value === 'number' || emptyValue === 0
        ? formatNumber((typeof value === 'number' ? value : emptyValue), precision !== null && precision !== void 0 ? precision : 0, separators.thousand, separators.decimal)
        : '';
}
exports.getFormattedString = getFormattedString;
//# sourceMappingURL=get-formatted-string.js.map